import {snakeCase} from "lodash-es";
import {FieldNames} from "models/fields";

export const ENTITY_TYPE = {
  assets: FieldNames.assets,
  indicators: FieldNames.indicators,
  observables: FieldNames.observables,
  relations: FieldNames.relations
};

/**
 * Create a unique String identifier for the Observable.
 * @param {Object} param0
 * @returns {String}
 */
export const getObservableHash = ({type, value}) =>
  snakeCase(`${type || ""}:${value}`);

/**
 * Creates a unique ID for an entity based on the data it contains
 *
 * @param {string} entityType type of @constant ENTITY_TYPE
 * @param {Object} entity data object for entity
 * @returns {string} unique ID
 */
export const getUniqueEntityId = (entityType, entity) => {
  // Observables
  if (entityType === ENTITY_TYPE.observables) {
    return `${entity?.type}:${entity?.value}`;
    // Assets
  } else if (entityType === ENTITY_TYPE.assets) {
    return `${entity?.type}:${entity?.observableType}:${entity?.value}`;
    // Relations
  } else if (entityType === ENTITY_TYPE.relations) {
    const {related, relation, source} = entity;
    return `${related?.type}:${related?.value}:${relation}:${source?.type}:${source?.value}`;
    // Indicators
  } else {
    return entity?.id;
  }
};
